{
  "it": {
    "task_assignment": {
      "actions": {
        "confirm": "Contrassegna come completata",
        "create": "Attività",
        "move_to_draft": "Riporta in bozza",
        "reopen": "Riapri",
        "send_and_notify": "Invia e notifica"
      },
      "assignee_types": {
        "customer": "Cliente",
        "employee": "Dipendente",
        "partner": "Partner"
      },
      "attributes": {
        "assignee": "Responsabile",
        "assignees": "Responsabili",
        "created_at": "Creato",
        "due_date": "Scadenza",
        "project": "Progetto",
        "status": "Stato",
        "task": "Attività",
        "unit": "Unità"
      },
      "confirm": {
        "affected": "Riguarda {customers} e {team}.",
        "affected_customers": "Riguarda {customers}.",
        "affected_team": "Riguarda {team}.",
        "complete_body": "Le loro attività vengono chiuse per loro e spariscono dal loro elenco, anche se non hanno fatto nulla.",
        "complete_header": "Chiudere questa attività per tutti?",
        "customer_tasks": "{count} attività per i clienti | {count} attività per i clienti",
        "draft_body": "L'attività sparisce finché non viene inviata di nuovo. Le e-mail già partite restano inviate.",
        "draft_header": "Riportare questa attività in bozza?",
        "send_customers": "I clienti vedono subito l'attività nel loro portale e ricevono una notifica.",
        "send_header": "Inviare agli assegnatari?",
        "send_permanent": "L'invio non può essere annullato. Riportare l'attività in bozza più tardi non ritira la notifica.",
        "send_status": "Passano a Richiesta.",
        "send_team": "I membri del team ricevono una notifica.",
        "team_tasks": "{count} attività per il team | {count} attività per il team"
      },
      "labels": {
        "add_assignee": "Aggiungi un responsabile…",
        "add_customers": "Aggiungi clienti",
        "already_assigned": "Questa attività è già stata aggiunta a questa unità.",
        "already_assigned_project": "Questa attività è già stata aggiunta a questo progetto.",
        "completed": "Completata",
        "confirm_message": "È sicuro di voler contrassegnare questa attività come completata?",
        "customers": "Clienti",
        "my_tasks": "Le mie attività",
        "no_assignees": "Ancora nessun responsabile assegnato.",
        "no_assignments": "Ancora nessuna attività.",
        "no_assignments_task": "Ancora nessuna assegnazione per questa attività.",
        "no_assignments_unit": "Ancora nessuna attività per questa unità.",
        "required": "Questo campo è obbligatorio",
        "select_task": "Selezioni un'attività",
        "upload_hint": "Carichi i documenti richiesti per completare questa attività.",
        "uploaded_documents": "Documenti caricati"
      },
      "statuses": {
        "completed": "Completata",
        "draft": "Bozza",
        "requested": "Richiesta"
      },
      "toasts": {
        "completed": "Attività completata",
        "create": "Attività creata",
        "delete": "Attività eliminata",
        "reopened": "Attività riaperta",
        "update": "Attività aggiornata"
      }
    }
  }
}
